import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center p-8">
        <div className="max-w-md text-center" data-testid="access-denied">
          <h2 className="text-2xl font-semibold mb-2">Access denied</h2>
          <p className="text-muted-foreground">Your role ({user.role}) doesn't allow access here.</p>
        </div>
      </div>
    );
  }
  return children;
}
